export default {
  dbi_compare_clear_all: '清空所有',
  dbi_compare_last_1_day: '上一天',
  dbi_compare_last_1_week: '上个星期',
  dbi_compare_last_1_month: '上个月',
  dbi_compare_last_3_month: '过去3个月',
  dbi_compare_last_6_month: '过去6个月',
  dbi_compare_last_12_month: '过去12个月',
  dbi_compare_pc_console_title: '电脑 & 主机游戏',
  dbi_compare_heat_map: '热力图',
  dbi_compare_show_top_3_countries: '显示前三个国家',
  dbi_compare_show_top_countries: '显示前{num}个国家',
  dbi_compare_label_device: '设备',
  dbi_compare_aligned_by_launch_time: '对齐发行时间',
  dbi_compare_add_game_to_compare: '添加游戏进行比较',
  dbi_compare_similar_games: '相似游戏',
  dbi_compare_selected: '已选',
  dbi_compare_not_select_game_yet: '你还没有选择游戏，',
  dbi_compare_please_search_game: '请在搜索框中搜索。',
  dbi_compare_please_search_game_only: '请在搜索框中搜索。',
  dbi_compare_please_search_game_above: '请在以上搜索框内搜索游戏。',
  dbi_compare_select_games_limit_tips: '最多可选择 {max} 个游戏进行比较',
  dbi_compare_add_games: '添加游戏',
  dbi_compare_clear_all_confirm_tips: '是否确定清空所有游戏？',
  dbi_compare_pc_console_download_tips:
    '按时间分割：将根据每日/每周/每月的粒度返回数据。聚合方法：将返回当前筛选器下的数据。',
  dbi_compare_no_pc_version_tips: '没有PC版本',
  dbi_compare_no_console_version_tips: '没有Console版本',
  dbi_compare_us_data_only_tips: '只有来自美国市场的数据',

  dbi_compare_mobile_current_store_rank: '当前商店排名',
  dbi_compare_mobile_key_metric_tips:
    'Sensor Tower与data.ai应用的算法模型不一致，在各个市场投入的成本资源不同（例如Sensor Tower在东南亚市场的投入相比annie会更高，而data.ai对于国家地区的资源倾斜第一梯队是美国、中国、日本，第二梯队是法国、德国、意大利、西班牙、英国、墨西哥、巴西、印度、俄罗斯、加拿大、韩国、澳大利亚、中国台湾、新加坡，其余国家为第三梯队），因此数据存在差异。',
  dbi_compare_mobile_current_rank: '当前排名',
  dbi_compare_mobile_countries_counts: '国家统计',
  dbi_compare_mobile_total_regions: '地区总数',
  dbi_compare_mobile_number_of_countries_rank: '排名 {rankRangeText}的国家数量',
  // 这个暂时无需翻译，但是代码里已经按照翻译的方式处理了，就不管了，万一以后产品要翻译 就直接改这里文案就好了
  dbi_compare_mobile_wow: 'WoW {num}',
  // 这个暂时无需翻译，但是代码里已经按照翻译的方式处理了，就不管了，万一以后产品要翻译 就直接改这里文案就好了
  dbi_compare_mobile_no: 'No.{num}',

  dbi_compare_pcconsole_same_start_date: 'Same Start Date(Incl.Align To Release)',
  dbi_compare_pcconsole_different_start_date: 'Different Start Date(For Event Analysis)',
  dbi_compare_pcconsole_games_beta_title: '多维对比-端游&主机游戏',
  dbi_compare_pcconsole_game_selection_empty: `You haven't selected the game yet. Please search in the search box or click the shortcut `,
  dbi_compare_pcconsole_game_filter_time_tips: `日周月粒度对应可选指标不同。例如：GSD指标仅在周粒度下可选。`,
  dbi_compare_pcconsole_game_filter_platform_tips: `当打开“对齐上线时间”时，切换平台，相应上线时间会变化。选择多平台时，相应上线时间对应为多平台中相对最早的上线时间。`,
  dbi_studio_competitor_game_selection_empty: `请在搜索框中搜索或点击快捷方式`,

  'POE-like': `流放之路类`,
  'Tarkov-like': `逃离塔科夫类`,
  'Dying Light 2-related': `消逝的光芒相关游戏`,
  'Dune-related': '沙丘相关游戏',

  dbi_compare_metric_pcu: 'PCU',
  dbi_compare_metric_acu: 'CCU',
  dbi_compare_metric_pcu_tips: '最高同时在线玩家',
  dbi_compare_metric_acu_tips: '同时在线玩家人数',
};
